<script setup>
import CardIndex from "@/components/card/CardIndex.vue";
import CardImport from "@/components/card/CardImport.vue";
import CardExport from "@/components/card/CardExport.vue";

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Data Card";

const route = useRoute();
const router = useRouter();

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];

const navigationTab = ref(route.query.export ? 2 : 0);
const tabItems = ["Search", "Import", "Export"];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">Search {{ pageTitle }}</h4>
  <VCard>
    <VTabs v-model="navigationTab">
      <VTab v-for="item in tabItems" :key="item">
        {{ item }}
      </VTab>
    </VTabs>
    <VWindow v-model="navigationTab">
      <VWindowItem :key="tabItems[0]">
        <CardIndex />
      </VWindowItem>
      <VWindowItem :key="tabItems[1]">
        <CardImport />
      </VWindowItem>
      <VWindowItem :key="tabItems[2]">
        <CardExport />
      </VWindowItem>
    </VWindow>
  </VCard>
</template>
